import React, {useState} from "react";
import cs from "classnames";
import {RadioGroup} from "@headlessui/react";
import {DesktopComputerIcon, DeviceMobileIcon} from "@heroicons/react/outline";

export type ViewSwitcherProps = {
    isMobile: boolean
    onChange?: (isMobile: boolean) => void
    classNames?: string
}

const ICON_SIZE = "h-6 w-6"
const options = [
    {key: "desktop", value: false, icon: <DesktopComputerIcon className={ICON_SIZE}/>},
    {key: "mobile", value: true, icon: <DeviceMobileIcon className={ICON_SIZE}/>}
]

const ViewSwitcher: React.FC<ViewSwitcherProps> = ({classNames, isMobile, onChange}) => {
    const [mobile, setMobile] = useState(isMobile)

    const wrappedOnChange = (isMobileSelected: boolean) => {
        if(onChange){
            onChange(isMobileSelected)
        }
        setMobile(isMobileSelected)
    }

    return (
        <div className={classNames}>
            <RadioGroup value={mobile} onChange={wrappedOnChange} className="">
                <div className="flex">
                    {options.map(({key, value, icon}) => <RadioGroup.Option
                            key={key}
                            value={value}
                            className={({active, checked}) =>
                                cs(
                                    checked
                                        ? 'bg-gray-300 border-transparent'
                                        : 'bg-white border-gray-200 hover:bg-gray-100',
                                    'border flex items-center justify-center py-0.5 px-3 text-gray-700 '
                                )
                            }
                        >
                            <RadioGroup.Label as="div">{icon}</RadioGroup.Label>
                        </RadioGroup.Option>
                    )}

                </div>
            </RadioGroup>
        </div>
    )
}
export default ViewSwitcher;

